// Village iron-golem spawning (MB.7). PURE (ENG-1). A village with enough
// villagers and beds — and no golem already guarding it — summons an iron golem.
// The host gathers the census (villagers/beds/golems in range); this owns the
// gate. (Panic-triggered emergency golems are a later remainder.)

/** A village needs at least this many villagers to warrant a golem (Java: 3+). */
export const GOLEM_MIN_VILLAGERS = 3;
/** …and at least this many beds (a real settlement, not two wanderers). */
export const GOLEM_MIN_BEDS = 3;

/** Whether a village should spawn an iron golem right now. */
export function canSpawnIronGolem(villagers: number, beds: number, golemsNearby: number): boolean {
  return villagers >= GOLEM_MIN_VILLAGERS && beds >= GOLEM_MIN_BEDS && golemsNearby === 0;
}
